import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FamiliaEquipo } from '@/app/models/FamiliaEquipo';
import { FamiliaequipoService } from '@/app/services/familiaequipo.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CrearFamiliaequipoComponent } from '@/app/components/catalogos/FamiliasEquipos/crear-familiaequipo/crear-familiaequipo.component';
import { EditarFamiliaequipoComponent } from '@/app/components/catalogos/FamiliasEquipos/editar-familiaequipo/editar-familiaequipo.component';

@Component({
    selector: 'app-lista-familiaequipo',
    templateUrl: './lista-familiaequipo.component.html',
    styleUrls: ['./lista-familiaequipo.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListaFamiliaequipoComponent {
  private spinner = inject(NgxSpinnerService);

  lista: FamiliaEquipo[] = [];

  constructor(
    private familiaEquipoService: FamiliaequipoService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
  ){
    this.getFamiliaEquipo();
  }

  getFamiliaEquipo(){
    this.spinner.show();

    this.familiaEquipoService.getFamiliaEquipo()
    .subscribe({
      next: (data: any) => {
        //console.log(data.Familia);
        this.lista = data.Familia;
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            console.log('aqui');
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);

      }
    });
  }

  abrirModalCrearFamiliaEquipo(){
    const dialogRef = this.dialog.open(CrearFamiliaequipoComponent, {
      width: '400px',
      height: '390px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getFamiliaEquipo();
    });

    this.router.events.subscribe( () => {
      dialogRef.close();
    });
  }

  abrirModalEditarFamiliaEquipo(registro: FamiliaEquipo){
    const dialogRef = this.dialog.open(EditarFamiliaequipoComponent, {
      width: '400px',
      height: '410px',
      panelClass: 'custom-dialog-container',
      data: registro,
      disableClose: true,
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getFamiliaEquipo();
    });

    this.router.events.subscribe( () => {
      dialogRef.close();
    });
  }

}
